import Choices from 'choices.js';

const termList = {

	container : document.querySelector('.termList'),
	mainButton : document.querySelector('.termList__mainButton'),
	selectList : document.querySelector('.termList__select'),
	choicesList : false,

	init: function(){
		if( termList.selectList ){
			// Init Choices list
			termList.choices = new Choices(termList.selectList, {
				searchPlaceholderValue: "Recherche une catégorie",
				position: 'bottom',
				shouldSort: false,
				itemSelectText: ''
			});
			termList.choicesList = document.querySelector(".termList .choices__inner");
	
			// Open list event
			termList.choices.passedElement.element.addEventListener('showDropdown', event => {
				if( termList.mainButton ){
					termList.mainButton.classList.add('hide');
				}
			})
	
			// Close list event
			termList.choices.passedElement.element.addEventListener('hideDropdown', event => {
				if( termList.mainButton ){
					termList.mainButton.classList.remove('hide');
				}
				if( termList.container ){
					termList.container.classList.remove('listOpen');
				}
			})
	
			// Handle page redirection on selection
			termList.selectRedirect();
	
			// Close/open filter animation
			termList.toggleList();
		}
	},

	selectRedirect : function(){
		if( termList.selectList ){
			termList.selectList.addEventListener('change', function(e){
				if( termList.mainButton ){
					let text = (termList.selectList.options[termList.selectList.selectedIndex].textContent != 'Tous')
					? termList.selectList.options[termList.selectList.selectedIndex].textContent
					: 'Filtrer par catégories';
					termList.mainButton.textContent = text
				}
				window.location = e.target.value;
			});
		}
	},

	toggleList : function(){
		if( termList.mainButton ){
			termList.mainButton.addEventListener('click', function(event) { 
				event.preventDefault(); 
				if( termList.choicesList && !termList.container.classList.contains('listOpen') ){
					termList.choicesList.click(); 
				}
				termList.container.classList.toggle("listOpen");
			});
		}
	}
	
}

export default termList;

